import { createIcon } from '@chakra-ui/react'

const IconMoreVertical = createIcon({
  displayName: 'IconMoreVertical',
  viewBox: '0 0 23 23',
  defaultProps: {
    boxSize: '23px'
  },
  path: (
    <>
      <circle cx="12" cy="5" r="1.5" fill="currentColor" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      <circle cx="12" cy="19" r="1.5" fill="currentColor" />
    </>
  )
})

export default IconMoreVertical
